<h1 mat-dialog-title
    *ngIf="!mobile">{{ 'default.memo'| blah}}</h1>
<mat-dialog-content>
    <div style="margin: 1px 0;">
        <mat-form-field id="memo-dialog-textarea">
            <mat-label>{{ 'default.memo' | blah }}</mat-label>
            <textarea matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="10"
                cdkAutosizeMaxRows="20"
                [(ngModel)]="memo"
                maxlength="4000"></textarea>
            <mat-hint align="end">{{memo.length || 0}} / 4000</mat-hint>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!mobile"
    align="end">
    <div class="pull-right">
        <button mat-button
            mat-stroked-button
            id="memo-dialog-close"
            (click)="close()">
            {{ 'default.cancel' | blah | uppercase }}
        </button>
        <button mat-button
            mat-flat-button
            color="accent"
            id="memo-dialog-save"
            [disabled]="saveDisabled()"
            (click)="save()">
            {{ 'default.save' | blah | uppercase }}
        </button>
    </div>
</mat-dialog-actions>